// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "client-ui" + "." + "21233e0aebe2d7c4c075" + ".css";
};